/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../css/pages/home.css';

import { toast } from 'react-toastify';
import moment from 'moment';
import { Link } from 'react-router-dom';
import {
  fetchBankAccounts, fetchStats, fetchWallet, withdrawFromWallet, fetchValidations,
} from '../actions/account';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import FundWalletInit from '../components/modals/FundWalletInit';
import Pin from '../components/modals/Pin';
import { fetchLoans } from '../actions/p2p';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loans: [],
      banks: [],
    };
  }

  componentDidMount() {
    try {
      const { fetchStats, fetchWallet } = this.props;
      fetchStats();
      fetchWallet();
      fetchLoans(1, '', 'amount_disbursed', 'DESC', 10, '', '', '&top=true')
        .then(({ data: { loans } }) => this.setState({ loans: loans.slice(0, 5) }))
        .catch(() => toast.error('An error occured fetching recent loans on your account.'));
      fetchValidations(1, '', 'created_on', 'DESC', 10, '', '', '')
        .then(({ data: { validations } }) => this.setState({ validations: validations.slice(0, 5) }))
        .catch(() => toast.error('An error occured fetching recent validations on your account.'));
      fetchBankAccounts()
        .then(({ data: banks }) => this.setState({ banks }))
        .catch(() => toast.error('An error occured fetching your bank accounts.'));
    } catch (error) {
      console.log(error);
    }
  }

  handleOnWithdraw = (pin) => {
    this.setState({ pin: null }, async () => {
      try {
        const { amount, banks } = this.state;
        const response = await withdrawFromWallet({ pin, amount, bank_id: banks[0].id });
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        this.props.fetchWallet();
      } catch (error) {
        toast.error(error.response?.data?.message || error.response?.statusText
          || error.message
          || 'Seems like something went wrong with your request. Please try again.');
      }
    });
  }

  fetchNextDueDate = (schedules) => {
    schedules = schedules.filter((schedule) => {
      const start = moment(new Date());
      const end = moment(new Date(schedule?.due_date));
      const duration = moment.duration(end.diff(start));
      if (duration.asMinutes() >= 0) {
        return true;
      }
      return false;
    });
    if (schedules.length > 0) {
      return schedules[0].due_date;
    }
    return '-';
  }

  render() {
    const {
      business, wallet, metrics, history, user,
    } = this.props;
    const {
      loans, validations, banks, fundWallet, pin,
    } = this.state;
    return (
      <>
        <SideNav page="dashboard" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="dashboard" />
            <section className="body-main__content">
              <div className="home">
                <div className="pageTitle d-lg-none">
                  <h3 className="pageTitle__header">
                    Hello,&nbsp;
                    {business.name}
                  </h3>
                  <p className="pageTitle__subheader">Welcome back!</p>
                </div>
                {(user?.type !== 'initiator') && (
                <div className="row">
                  <div className="col-12 col-xl-7">
                    <div className="home__wallet">
                      <div className="home__wallet--top">
                        <div className="left-content">
                          <p className="home__wallet--title">Wallet Balance</p>
                          {!Number.isNaN(+wallet.availableBalance) && (
                            <h3 className="amount">
                              <span className="amount__naira">
                                ₦
                                {Number(String(wallet.availableBalance || 0)?.split('.')[0]).toLocaleString()}
                              </span>
                              .
                              <span className="amount__kobo">{String(wallet.availableBalance || 0)?.split('.')[1] || '00'}</span>
                            </h3>
                          )}
                          {Number.isNaN(+wallet.availableBalance) && (
                            <h3 className="amount">
                              <span className="amount__naira">
                                N/A
                              </span>
                            </h3>
                          )}
                        </div>
                        <div className="right-content">
                          <div className="d-inline-flex align-items-center">
                            <p className="home__wallet--title">
                              {wallet?.virtual_accounts?.[0]?.bank_name}
                            </p>
                          </div>
                          <h3 className="acc-number">
                            {wallet?.virtual_accounts?.[0]?.account_number}
                          </h3>
                        </div>
                      </div>
                      <div className="home__wallet--bottom">
                        <button
                          type="button"
                          className="btn btn-outline-primary my-auto"
                          onClick={() => this.setState({ pin: true })}>
                          Withdraw From Wallet
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-xl-5">
                    <div className="home__linkaccount">
                      <div className="home__linkaccount-done">
                        <div className="title-and-btn">
                          <h3>Bank Account</h3>
                        </div>
                        <div className="details">
                          <div className="details__group">
                            <p className="details__title">Account Name</p>
                            <p className="details__value">{banks?.[0]?.account_name || 'N/A'}</p>
                          </div>
                          <div className="details__group">
                            <p className="details__title">Account number</p>
                            <p className="details__value">{banks?.[0]?.account_number || 'N/A'}</p>
                          </div>
                          <div className="details__group">
                            <p className="details__title">Bank Name</p>
                            <p className="details__value">{banks?.[0]?.code_description || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                )}
                {(user?.type === 'business' || user?.type === 'initiator') && (
                <div className="default-card home__stats">
                  <div className="row">
                    <div className="col-12 col-md-3 home__stats--group">
                      <div className="home__stats--group-content">
                        <p>Outstanding Principal</p>
                        <h3>
                          ₦
                          {Number(metrics?.summary?.outstanding_principal || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 home__stats--group">
                      <div className="home__stats--group-content">
                        <p>Outstanding Interest</p>
                        <h3>
                          ₦
                          {Number(metrics?.summary?.outstanding_earning || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 home__stats--group">
                      <div className="home__stats--group-content">
                        <p>Total Loan Disbursed</p>
                        <h3>
                          ₦
                          {Number(metrics?.summary?.total_principal || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </h3>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 home__stats--group">
                      <div className="home__stats--group-content">
                        <p>Total Earned</p>
                        <h3>
                          ₦
                          {Number(metrics?.summary?.total_income || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                )}
                {!!loans?.length && (user?.type === 'business' || user?.type === 'initiator') && (
                  <div className="row my-4">
                    <div className="col-12">
                      <div className="default-card page-table">
                        <div className="table-nav">
                          <div className="table-title">
                            <p className="table-title-text">Top Loans</p>
                          </div>
                          <div className="view-more">
                            <Link className="view-more-link" to="/loans">View More</Link>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="name">Name</th>
                                <th className="loan_amount">Loan Amount</th>
                                <th className="amount_paid">Amount Paid</th>
                                <th className="loan_balance">Loan Balance</th>
                                <th className="amount_due">Pending Due</th>
                                <th className="status">Status</th>
                                <th className="date-time">Next Due Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loans.map((loan) => (
                                <tr key={loan.id} role="button" onClick={() => history.push(`loans/${loan.id}`)}>
                                  <td className="name text-nowrap">
                                    {loan?.user?.first_name}
                                    {' '}
                                    {loan?.user?.last_name}
                                  </td>
                                  <td className="loan_amount text-nowrap">{Number(loan.loan_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                  <td className="amount_paid text-nowrap">{Number(loan.paid || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                  <td className="loan_balance text-nowrap">{Number(loan?.schedules?.reduce((acc, schedule) => acc + schedule.amount_due, 0) || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                  <td className="amount_due text-nowrap">{Number(loan?.schedules?.reduce((acc, schedule) => (moment(schedule.due_date).isSameOrBefore(new Date()) ? acc + schedule.amount_due : acc + 0), 0) || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                  <td className="status text-nowrap">{loan?.status?.status}</td>
                                  <td className="date-time text-nowrap">
                                    <span className="date">
                                      {
                                      this.fetchNextDueDate(loan?.schedules) === '-' ? '---' : moment(this.fetchNextDueDate(loan?.schedules)).format('MMM DD, YYYY, h:mm:ss a')
                                      }

                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {!!validations?.length && (user?.type !== 'business' && user?.type !== 'initiator') && (
                  <div className="row my-4">
                    <div className="col-12">
                      <div className="default-card page-table">
                        <div className="table-nav">
                          <div className="table-title">
                            <p className="table-title-text">Recent Validations</p>
                          </div>
                          <div className="view-more">
                            <Link className="view-more-link" to="/validations">View More</Link>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="uuid">UUID</th>
                                <th className="ip">IP</th>
                                <th className="match">Match Status</th>
                                <th className="charge">Charge</th>
                                <th className="payment">Payment Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {validations.map((log) => (
                                <tr key={log.id} role="button">
                                  <td className="uuid text-nowrap">
                                    {log?.uuid}
                                  </td>
                                  <td className="ip text-nowrap">{log?.ip}</td>
                                  <td className="match text-nowrap">{log?.response?.img_matches ? 'success' : 'failed'}</td>
                                  <td className="charge text-nowrap">{Number(log.charge || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                  <td className="payment_status text-nowrap">{log?.payment_status}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </section>
          </div>
        </main>
        <FundWalletInit
          visible={fundWallet}
          onClose={() => this.setState({ fundWallet: false })} />
        <Pin
          body={(
            <div className="form-group">
              <label htmlFor="amount" className="form-label">How much do you want to withdraw?</label>
              <input
                type="number"
                className="form-control"
                id="amount"
                name="amount"
                onChange={(e) => this.setState({ amount: e.target.value })}
                placeholder="Enter Amount"
                required />
            </div>
          )}
          visible={pin}
          onClose={() => this.setState({ pin: null })}
          onSubmit={this.handleOnWithdraw} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  business: state.account?.business || {},
  wallet: state.account?.wallet || {},
  metrics: state.account?.metrics || {},
  user: state.account?.user || {},
});

const mapDispatchToProps = {
  fetchStats,
  fetchWallet,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);
